import { atom } from "jotai";

/**
 * Tracks whether the RevenueCat SDK has been successfully configured.
 * Set by useRevenueCatInit, consumed by useIsSubscribed / useOfferings
 * to make react-query `enabled` reactive.
 */
export const revenueCatReadyAtom = atom(false);
revenueCatReadyAtom.debugLabel = "revenuecat-ready";

export const showExploreGamesAtom = atom(false);
showExploreGamesAtom.debugLabel = "show-explore-games";
